module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_tvb-9fd08cc9b365a8d7e3459779aeef5c90.jpg";